import React from 'react';
import { Chip } from '@material-ui/core';

const StatBadge = ({ label, value, color = 'default' }) => (
  <Chip label={`${label}: ${value}`} color={color} size="small" />
);

export default StatBadge;
